import React from 'react';
import CellContent from '../../../../common/CellContent/CellContent';
import { columnKeyMap } from '../../constants/columnKeyMap';
import moment from 'moment';
import AccessTypeContent from '../../../AccessTypeContent/AccessTypeContent';

const { accountMark, account, fio, address, openDate, closeDate, accessType } =
  columnKeyMap;

export const getAccountsTableColumns = (
  sortedInfo,
  registrationTypeHouse,
  isVisibleType
) => [
  {
    title: 'Признак',
    dataIndex: 'type.name',
    key: accountMark,
    colSpan: 1,
    width: '8%',
    sorter: true,
    sortOrder: sortedInfo?.columnKey === accountMark && sortedInfo?.order,
    render: (mark) => (
      <CellContent
        topRowContent={mark}
        isHighlighted
      />
    ),
  },
  {
    title: 'Номер',
    dataIndex: account,
    key: account,
    width: '17%',
    colSpan: 1,
    sorter: true,
    sortOrder: sortedInfo?.columnKey === account && sortedInfo?.order,
    render: (number) => (
      <CellContent
        topRowContent={number}
        isHighlighted
      />
    ),
  },
  {
    title: 'ФИО',
    key: fio,
    colSpan: 1,
    width: '20%',
    sorter: true,
    sortOrder: sortedInfo?.columnKey === fio && sortedInfo?.order,
  },
  {
    title: 'Адрес',
    dataIndex: address,
    key: address,
    colSpan: 1,
    width: !!isVisibleType ? '28%' : '33%',
    sorter: true,
    sortOrder: sortedInfo?.columnKey === address && sortedInfo?.order,
    render: (address) => <CellContent topRowContent={address} />,
  },
  {
    title: 'Дата открытия ЛС',
    dataIndex: openDate,
    key: openDate,
    colSpan: 1,
    width: !!isVisibleType ? '9%' : '11%',
    sorter: true,
    sortOrder: sortedInfo?.columnKey === openDate && sortedInfo?.order,
    render: (openDate) => (
      <CellContent
        topRowContent={
          !!openDate ? moment(openDate).format('DD.MM.YYYY') : null
        }
        isHighlighted={!!openDate}
      />
    ),
  },
  {
    title: 'Дата закрытия ЛС',
    dataIndex: closeDate,
    key: closeDate,
    colSpan: 1,
    width: !!isVisibleType ? '9%' : '11%',
    sorter: true,
    sortOrder: sortedInfo?.columnKey === closeDate && sortedInfo?.order,
    render: (closeDate) => (
      <CellContent
        topRowContent={
          !!closeDate ? moment(closeDate).format('DD.MM.YYYY') : null
        }
        isHighlighted={!!closeDate}
      />
    ),
  },
  ...(!!isVisibleType
    ? [
        {
          title: 'Настройка регистрации',
          dataIndex: accessType,
          key: accessType,
          colSpan: 1,
          width: '9%',
          sorter: true,
          sortOrder: sortedInfo?.columnKey === accessType && sortedInfo?.order,
          render: (accessType, record) => (
            <AccessTypeContent
              accessType={accessType}
              record={record}
              registrationTypeHouse={registrationTypeHouse}
            />
          ),
        },
      ]
    : []),
];
